import { render } from "./AuthResetIcon.vue?vue&type=template&id=af1c819e"
import script from "./AuthResetIcon.vue?vue&type=script&lang=js"
export * from "./AuthResetIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__